import { render, staticRenderFns } from "./WorkspaceLogoUpload.vue?vue&type=template&id=1ae80a3a&scoped=true&"
import script from "./WorkspaceLogoUpload.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceLogoUpload.vue?vue&type=script&lang=ts&"
import style0 from "./WorkspaceLogoUpload.vue?vue&type=style&index=0&id=1ae80a3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae80a3a",
  null
  
)

export default component.exports